import getIcon from 'src/utils/getIcon';

import { CoreAlertBannerData, Icon } from 'src/types/components';

import styles from './AlertIcon.module.scss';

type AlertIconProps = {
  bannerType: CoreAlertBannerData['fields']['bannerType'];
  bannerIcon: CoreAlertBannerData['fields']['bannerIcon'];
};
const AlertIcon = ({ bannerType, bannerIcon }: AlertIconProps) => {
  const iconClass = styles.icon;

  if (bannerType === 'standard' && bannerIcon) {
    const BannerIcon = getIcon({ type: bannerIcon });
    if (!BannerIcon) {
      return null;
    }
    return <BannerIcon className={iconClass} id="banner-type" aria-label="Alert." />;
  }

  const BannerIcon = getIcon({ type: bannerType as Icon });

  if (!BannerIcon) {
    return null;
  }

  return <BannerIcon id="banner-type" className={iconClass} aria-label={`${bannerType}.`} />;
};

export default AlertIcon;
